define('plugin/facebook-pixel/MembershipInflator',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Membership inflator for Facebook Pixel plugin
     *
     * @class MembershipInflator
     */
    return Marionette.Object.extend({
        inflate: function (contentData, model, data) {
            var membershipData = model.get('membership');
            console.log(membershipData)
            _.extend(contentData, {
                content_ids: [model.get('id')],
                content_type: model.get('type'),
                contents: [{
                    id: membershipData.id,
                    name: membershipData.name,
                    price: parseFloat(membershipData.first_price),
                    membership: {
                        duration: membershipData.duration,
                        duration_type: membershipData.duration_type,
                        active: membershipData.is_active,
                        unlimited: membershipData.is_unlimited,
                        recurring: membershipData.is_recurring,
                        recurring_price: membershipData.recurring_price
                    },
                }],
                period_start: model.get('period_start')
            });
        }
    });

});

